import { useMutation } from "urql";
import { graphql } from "../../../__generated__/gql";
import Modal from "../../../ui/Modal/Modal";
import { useCallback } from "react";
import { useToast } from "../../../ui/Toast/ToastContext";
import ConfirmationModal from "../../../ui/Modal/ConfirmationModal";

const AddKeywordAsDraftMutation = graphql(/* GraphQL */ `
  mutation addKeywordsAsDraft($input: CreateArticlesInput!) {
    createArticles(input: $input) {
      ... on CreateArticlesResult {
        count
      }
      ... on InsufficientCreditsError {
        __typename
        message
      }
    }
  }
`);

function InnerAddKeywordsAsDraftModal({
  onClose,
  keywords,
}: {
  onClose: () => void;
  keywords: string[];
}) {
  const { showToast } = useToast();

  const [addKeywordAsDraftResponse, addKeywordAsDraft] = useMutation(
    AddKeywordAsDraftMutation,
  );

  const onSubmit = useCallback(async () => {
    const response = await addKeywordAsDraft({
      input: {
        keywords,
        draft: true,
      },
    });

    if (
      response.data?.createArticles.__typename === "InsufficientCreditsError"
    ) {
      showToast({
        variant: "error",
        title: "You've run out of article credits",
      });
    } else {
      showToast({ title: "Keywords added as draft" });
    }

    onClose();
  }, [addKeywordAsDraft, keywords, onClose, showToast]);

  return (
    <ConfirmationModal
      onClose={onClose}
      onSubmit={onSubmit}
      loading={addKeywordAsDraftResponse.fetching}
    />
  );
}

function AddKeywordsAsDraftModal({
  isOpen,
  onClose,
  keywords,
}: {
  isOpen: boolean;
  onClose: () => void;
  keywords: string[];
}) {
  const title = `Create ${keywords.length} draft ${
    keywords.length === 1 ? "article" : "articles"
  }?`;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <InnerAddKeywordsAsDraftModal onClose={onClose} keywords={keywords} />
    </Modal>
  );
}

export default AddKeywordsAsDraftModal;
